import React from 'react'

import Caros from './caros';
import Trending from './Trending';
import Women from './Women';
import Newssection from './Newssection';
import Article from './Article';
import Demo from './Demo';
import Footerdemo from './Footerdemo';
import Landing from './Landing';
import Header from './Header';
import Navbar from './Navbar';
import Idea from './Idea';
import MagazineShowcase from './MagazineShowcase';

export default function Home() {
  return (
    <>
     <Navbar/>
   <Landing/>
   <Header/>
   <Caros/>
   <Trending/>
   <Women/>
   <Newssection/>
   <Demo/>
   <Article/>
   {/* <MagazineShowcase/> */}
   {/* <Idea/> */}
   {/* <Footerdemo/> */}
    </>
  )
}
